module.exports = new __parcel__URL__("projects-directory-app-skeleton.tpl.a21368f6.svg").toString();